import { CeruleanButton } from 'components/Button'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import formName from 'constants/formName'
import { selectors } from 'data'
import { ChangePasswordFormType } from 'data/types'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { InjectedFormProps, reduxForm } from 'redux-form'
import styled from 'styled-components'
import { validator } from 'utils'

import asyncValidate from '../../Modal/asyncValidatePassword'
import Container from '../../Modal/Container'
import { ChangePasswordStrength } from '../../Modal/PasswordStrength'
import { PropsType as _P } from '.'

const isSameAsPassword = validator.isSameAs('newPassword')
const isDifferentFromOldPassword = validator.isDifferentFrom('oldPassword')

const PasswordContainer = styled.div`
  position: relative;
`

// eslint-disable-next-line react/no-unused-prop-types
type NotFormProps = _P & WrappedComponentProps & { form: string }
type PropsType = InjectedFormProps<ChangePasswordFormType, NotFormProps> & NotFormProps

const ChangePassword = ({ fieldLoading, handleSubmit, intl, valid }: PropsType) => (
  <form onSubmit={handleSubmit}>
    <Container
      sub={intl.formatMessage(messages.sub_title_change_password)}
      title={intl.formatMessage(messages.title_change_password)}
    >
      <InputContainer>
        <Field
          autoComplete='current-password'
          component={Input}
          data-lpignore='true'
          e2e='oldPasswordInput'
          label={intl.formatMessage(messages.label_old_password)}
          name='oldPassword'
          type='password'
          validate={[validator.required]}
        />
      </InputContainer>

      <PasswordContainer>
        <ChangePasswordStrength />
        <InputContainer>
          <Field
            asyncValidate
            autoComplete='new-password'
            component={Input}
            data-lpignore='true'
            e2e='newPasswordInput'
            label={intl.formatMessage(messages.label_password_new)}
            loading={fieldLoading === 'newPassword'}
            name='newPassword'
            placeholder={intl.formatMessage(messages.placeholder_password_new)}
            showPassword
            type='password'
            validate={[validator.required, isDifferentFromOldPassword]}
          />
        </InputContainer>
      </PasswordContainer>

      <InputContainer>
        <Field
          autoComplete='new-password'
          component={Input}
          data-lpignore='true'
          e2e='confirmPasswordInput'
          label={intl.formatMessage(messages.label_confirm_password)}
          name='confirmPassword'
          type='password'
          validate={[validator.required, isSameAsPassword]}
        />
      </InputContainer>

      <CeruleanButton disabled={!valid} e2e='changePasswordButtonSubmit' type='submit'>
        {intl.formatMessage(messages.button_change_password)}
      </CeruleanButton>
    </Container>
  </form>
)

export default injectIntl(
  reduxForm<ChangePasswordFormType, NotFormProps>({
    asyncChangeFields: ['newPassword'],
    asyncValidate,
    form: formName.CHANGE_PASSWORD,
    initialValues: selectors.changePassword.initialValues
  })(ChangePassword)
)
